import axios from "axios";
import RequestManager from "../lib/requestManager";
import { getFileMakerCredentials } from "../lib/env";

export class FileMaker {
  constructor(JWT: any) {
    this.JWT = JWT;
  }
  private domain = 'https://mitsqa.cms.org/fmi/data/vLatest/databases/mitsqa';
  
  private JWT = "";
  private token = "";
  getBoardMeetings = async (): Promise<any> => {
    try {
      const resp = await axios.get(
        `${this.domain}/layouts/BOD Mtg Summary/records?_sort=[{ "fieldName": "Meeting Date", "sortOrder": "descend" }]`,
        {
          headers: {
            Authorization: `Bearer ${this.JWT}`,
          },
        }
      );
      return resp.data.response.data;
    } catch (error: any) {
      return false;
    }
  };
  search = async (searchQuery: any): Promise<any> => {
    try {
      const resp = await axios.post(
        `${this.domain}/layouts/View/_find`,
        {
          query: [searchQuery],
        },
        {
          headers: {
            Authorization: `Bearer ${this.JWT}`,
          },
        }
      );
      // const resp = await axios.post(
      //   `${this.domain}/layouts/Find_a_Physician_Search/_find`,
      //   query,
      //   {
      //     headers: {
      //       Authorization: `Bearer ${this.JWT}`,
      //     },
      //   }
      // );
      return resp.data.response.data;
    } catch (error: any) {
      return false;
    }
  };
  getToken = async (retryCount = 0): Promise<any> => {
    const maxRetries = 3;
    try {
      // Get credentials from environment variables
      const { username, password } = getFileMakerCredentials();
      const credentials = Buffer.from(`${username}:${password}`).toString('base64');
      
      console.log(`FileMaker: Attempting to get token from ${this.domain}/sessions`);
      console.log(`FileMaker: Using credentials for user: ${username}`);
      
      const resp = await axios.post(
        `${this.domain}/sessions`,
        {},
        {
          headers: {
            Authorization: `Basic ${credentials}`,
          },
        }
      );
      return resp.data.response.token;
    } catch (error: any) {
        console.warn(`FileMaker: Token fetch failed. Retry ${retryCount + 1}/${maxRetries}...`);
        console.error("FileMaker: Token fetch error details:", error.response?.data || error.message);
        if (retryCount < maxRetries) {
          await new Promise((res) => setTimeout(res, 1000));
          return await this.getToken(retryCount + 1);
        } else {
          console.error("FileMaker: Token fetch failed after maximum retries:", error);
          throw new Error("Failed to obtain authentication token");
        }
    }
  };
getProposals = async (fmStatus: any, cmsId: any): Promise<any[]> => {
  const requestManager = RequestManager.getInstance();
  const endpoint = 'getProposals';

  if (!requestManager.canMakeRequest(endpoint)) {
    console.warn("⏳ Request blocked by rate limiter");
    return [];
  }

  try {
    if (!this.JWT) {
      console.error("❌ No JWT token available for API call");
      return [];
    }

    requestManager.recordRequest(endpoint);

    const policyBoardMtgId = sessionStorage.getItem("policyBoardMtgId");
    let searchQuery;

    // 🔹 If fmStatus and cmsId are '*', use Policy Board Meeting ID if available
    if (fmStatus === '*' && cmsId === '*') {
      if (policyBoardMtgId) {
        searchQuery = {
          query: [
            {
              "ID": "*",
              "Policy Board Mtg ID": policyBoardMtgId
            }
          ],
          limit: "10000",
          offset: "1"
        };
      } 
    } 
    else if (cmsId === '*') {
      searchQuery = {
        query: [
          {
            "ID": "*",
            "Policy FM Status": fmStatus
          }
        ],
        limit: "10000",
        offset: "1"
      };
    } 
    else if (fmStatus === '*') {
      searchQuery = {
        query: [
          {
            "ID": "*",
            "CMS ID": cmsId
          }
        ],
        limit: "10000",
        offset: "1"
      };
    } 
    else {
      searchQuery = {
        query: [
          {
            "ID": "*",
            "CMS ID": cmsId,
            "Policy FM Status": fmStatus
          }
        ],
        limit: "10000",
        offset: "1"
      };
    }

    // 🔹 Perform FileMaker search
    const resp = await axios.post(
      `${this.domain}/layouts/Policies/_find`,
      searchQuery,
      {
        headers: { Authorization: `Bearer ${this.JWT}` },
        timeout: 30000
      }
    );

    const data = resp.data?.response?.data;
    if (data && Array.isArray(data)) {
      return data;
    } else {
      console.error("⚠️ Unexpected response structure:", resp.data);
      return [];
    }

  } catch (error: any) {
    console.error("❌ Error in getProposals:", error.response?.data || error.message || error);
    requestManager.recordError();
    return [];
  }
};



getBoardMtgId = async (cmsId: string): Promise<any> => {
  try {
    const query = {
      query: [
        {
          "CMS ID": cmsId,
        },
      ],
    };

    // 👇 Adjust "Policy Token" to match your actual layout name
    const resp = await axios.post(
      `${this.domain}/layouts/Policy Token/_find`,
      query,
      {
        headers: {
          Authorization: `Bearer ${this.JWT}`,
        },
      }
    );

    // FileMaker returns results in resp.data.response.data
    const results = resp.data?.response?.data || [];

    if (results.length > 0) {
      // Return the first record’s field data (you can adjust this if you need all)
      return results[0].fieldData;
    }

    return null;
  } catch (error: any) {
    console.error("Error fetching Board Meeting ID from FileMaker:", error.response?.data || error.message);
    return null;
  }
};


  getBoardDetails = async (boardID: string): Promise<any> => {
    try {
      let query = {
        query: [
          {
            "ID": "*",
            "Policy Board Mtg ID": boardID
          },
        ],
      };
      const resp = await axios.post(`${this.domain}/layouts/Policies/_find`,
        query,
       {
        headers: {
          Authorization: `Bearer ${this.JWT}`,
        },
      });
      return resp.data.response.data;
    } catch (error: any) {
      return false;
    }
  };

  getProposalDetails = async (id: string): Promise<any> => {
    try {
      const resp = await axios.get(
        `${this.domain}/layouts/Policies/records/${id}`,
        {
          headers: {
            Authorization: `Bearer ${this.JWT}`,
          },
        }
      );
      return resp.data.response.data[0];
    } catch (error: any) {
      return false;
    }
  };
  getMemberNotice = async (CMSId: string): Promise<any> => {
    try {
      let query = {
        query: [
          {
            "CMS ID": CMSId,
          },
        ],
        "offset" : "1",
        "limit.Optional Line Item ONLINE" : "1000",
        "limit.Required Line Item ONLINE" : "1000"
      };
      const resp = await axios.post(
        `${this.domain}/layouts/CMS Membership Notice/_find`,
        query,
        {
          headers: {
            Authorization: `Bearer ${this.JWT}`,
          },
        }
      );
      return resp.data.response.data[0];
    } catch (error: any) {
      return false;
    }
  };

  getUpdatedMemberNotice = async (CMSId: string): Promise<any> => {
    try {
      let query = {
        query: [
          {
            "CMS ID": CMSId,
          },
        ],
      };
      const resp = await axios.post(
        `${this.domain}/layouts/CMS_line_item/_find`,
        query,
        {
          headers: {
            Authorization: `Bearer ${this.JWT}`,
          },
        }
      );
      return resp.data.response.data;
    } catch (error: any) {
      return false;
    }
  };
  updateMemberNotice = async (id: string, data: any): Promise<any> => {
    try {
      const resp = await axios.patch(
        `${this.domain}/layouts/CMS Membership Notice/Records/${id}`,
        data,
        {
          headers: {
            Authorization: `Bearer ${this.JWT}`,
          },
        }
      );
      return resp.data.response.data[0];
    } catch (error: any) {
      return false;
    }
  };
  verifyMember = async (firstName: string, lastName: string): Promise<any> => {
    try {
      let query = {
        query: [
          {
            "First Name": firstName,
            "Last Name": lastName,
          },
        ],
      };
      const resp = await axios.post(
        `${this.domain}/layouts/View/_find`,
        query,
        {
          headers: {
            Authorization: `Bearer ${this.JWT}`,
          },
        }
      );
      return resp.data.response.data[0];
    } catch (error: any) {
      return false;
    }
  };
  findMemberForRenewal = async (
    lastName: string,
    CMSNo: string,
    CMLNo: string
  ): Promise<any> => {
    try {
      //TODO Fix this
      let query = {
        query: [
          {
            //"Last Name": lastName,
            "CO License Number": CMLNo,
            "CMS ID": CMSNo,
          },
        ],
      };
      const resp = await axios.post(
        `${this.domain}/layouts/View/_find`,
        query,
        {
          headers: {
            Authorization: `Bearer ${this.JWT}`,
          },
        }
      );
      return resp.data.response.data[0];
    } catch (error: any) {
      return false;
    }
  };
  makePayment = async (data: any): Promise<any> => {
    try {
      const resp = await axios.post(`http://localhost:3000/api/pmt`, data, {});
      return resp.data.response.data;
    } catch (error: any) {
      return false;
    }
  };
  login = async (AMA: string, pwd: string): Promise<any> => {
    try {
      let query = {
        query: [
          {
            "AMA ME No": AMA,
            "EE Init Password": pwd,
          },
        ],
      };
      const resp = await axios.post(
        `${this.domain}/layouts/View/_find`,
        query,
        {
          headers: {
            Authorization: `Bearer ${this.JWT}`,
          },
        }
      );
      return resp.data.response.data[0];
    } catch (error: any) {
      return false;
    } 
  };

  createOnlineTransaction = async (cmsData: any): Promise<any> => {
    try {
      const resp = await axios.post(
        `${this.domain}/layouts/Online%20Transaction/records`,
        cmsData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.JWT}`,
          },
        }
      );
      return resp.data;
    } catch (error: any) {
      return false;
    }
  };

   createRecord = async (memberData: any): Promise<any> => {
    try {
      const resp = await axios.post(
        `${this.domain}/layouts/Member Info/records`,
        memberData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.JWT}`,
          },
        }
      );
      return resp.data;
    } catch (error: any) {
      return error;
    }
  };
    submitProposal = async (memberData: any): Promise<any> => {
      try {
        const resp = await axios.post(
          `${this.domain}/layouts/Policies/records`,
          memberData,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.JWT}`,
            },
          }
        );
        return resp.data;
      } catch (error: any) {
        return false;
      }
    };



    getCity = async (): Promise<any> => {
      try {
        let query = {
          query: [
            {
               "Name": "*",
               "Component Society::Active": "Yes"
            },
          ],
          "limit": "1000",
          "offset": "1"
        };
        const resp = await axios.post(
          `${this.domain}/layouts/Colorado City/_find`,
          query,
          {
            headers: {
              Authorization: `Bearer ${this.JWT}`,
            },
          }
        );
        return resp.data.response.data;
      } catch (error: any) {
        return false;
      }
    };

    
    // Find existing vote by Policy ID and CMS ID - CMS API Requirements
    existingLoopVote = async (policyId: string, cmsId: string): Promise<any> => {
 
      try {
        // Exact query structure from CMS API requirements
        const query = {
          query: [
            {
              "Policy Idea ID": policyId,
              "CMS ID": cmsId
            }
          ]
        };

        const resp = await axios.post(
          `${this.domain}/layouts/Policy Votes/_find`,
          query,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.JWT}`,
            },
            timeout: 10000
          }
        );
        // Validate response structure
        if (resp.data?.response?.data && resp.data.response.data.length > 0) {
          const voteData = resp.data.response.data[0];
          console.log(`Found existing vote for Policy ${policyId}, CMS ${cmsId}`);
          return voteData;
        } else {
          console.log(`No existing vote found for Policy ${policyId}, CMS ${cmsId}`);
          return null;
        }
      } catch (error: any) {
         return null;
      }
    };
    
    findVote = async (memberData: any): Promise<any> => {
      const requestManager = RequestManager.getInstance();
      const endpoint = 'findVote';
      
      // Check rate limiting
      // if (!requestManager.canMakeRequest(endpoint)) {
      //   console.warn("findVote request blocked by rate limiter");
      //   return [];
      // }

      try {
        // Check if we have a valid JWT
        if (!this.JWT) {
          console.error("No JWT token available for findVote");
          return [];
        }

        // Record this request
        requestManager.recordRequest(endpoint);

        const resp = await axios.post(
          `${this.domain}/layouts/Policy Votes/_find`,
          memberData,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.JWT}`,
            },
            timeout: 10000 // 10 second timeout
          }
        );
        return resp.data.response.data || [];
      } catch (error: any) {
        console.error("CMS Policy API Error:", error.response?.data || error);
        requestManager.recordError();
        return [];
      }
    };
    submitVote = async (memberData: any): Promise<any> => {
      const requestManager = RequestManager.getInstance();
      const endpoint = 'submitVote';
      
      // Check rate limiting
      if (!requestManager.canMakeRequest(endpoint)) {
        console.warn("submitVote request blocked by rate limiter");
        return false;
      }

      try {
        // Check if we have a valid JWT
        if (!this.JWT) {
          console.error("No JWT token available for submitVote");
          return false;
        }

        // Record this request
        requestManager.recordRequest(endpoint);

        const resp = await axios.post(
          `${this.domain}/layouts/Policy Votes/records`,
          memberData,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.JWT}`,
            },
            timeout: 10000 // 10 second timeout
          }
        );
        return resp.data.response;
      } catch (error: any) {
        console.error("CMS Policy API Error:", error.response?.data || error);
        requestManager.recordError();
        return false;
      }
    };
// Add this method to your FileMaker class
getVotesByUser = async (cmsId: string): Promise<any[]> => {
  const requestManager = RequestManager.getInstance();
  const endpoint = 'getVotesByUser';
  
  // Check rate limiting
  if (!requestManager.canMakeRequest(endpoint)) {
    console.warn("getVotesByUser request blocked by rate limiter");
    return [];
  }

  try {
    // Check if we have a valid JWT
    if (!this.JWT) {
      console.error("No JWT token available for getVotesByUser");
      return [];
    }

    // Record this request
    requestManager.recordRequest(endpoint);

    // Query to find all votes by this user
    const query = {
      query: [
        {
          "CMS ID": cmsId
        }
      ]
    };

    const resp = await axios.post(
      `${this.domain}/layouts/Policy Votes/_find`,
      query,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.JWT}`,
        },
        timeout: 10000
      }
    );

    // Validate response structure
    if (resp.data?.response?.data && Array.isArray(resp.data.response.data)) {
      console.log(`Found ${resp.data.response.data.length} votes for user ${cmsId}`);
      return resp.data.response.data;
    } else {
      console.log(`No votes found for user ${cmsId}`);
      return [];
    }
  } catch (error: any) {
    console.error("CMS Policy API Error - Get Votes By User:", error.response?.data || error);
    requestManager.recordError();
    return [];
  }
};
    // Find existing vote by Policy ID and CMS ID - CMS API Requirements
    findVoteByPolicyAndUser = async (policyId: string, cmsId: string): Promise<any> => {
      const requestManager = RequestManager.getInstance();
      const endpoint = 'findVote';
      
      // Check rate limiting
      if (!requestManager.canMakeRequest(endpoint)) {
        console.warn("findVote request blocked by rate limiter");
        return null;
      }

      try {
        // Check if we have a valid JWT
        if (!this.JWT) {
          console.error("No JWT token available for findVote");
          return null;
        }

        // Record this request
        requestManager.recordRequest(endpoint);

        // Exact query structure from CMS API requirements
        const query = {
          query: [
            {
              "Policy Idea ID": policyId,
              "CMS ID": cmsId
            }
          ]
        };

        const resp = await axios.post(
          `${this.domain}/layouts/Policy Votes/_find`,
          query,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.JWT}`,
            },
            timeout: 10000
          }
        );
        // Validate response structure
        if (resp.data?.response?.data && resp.data.response.data.length > 0) {
          const voteData = resp.data.response.data[0];
          console.log(`Found existing vote for Policy ${policyId}, CMS ${cmsId}`);
          return voteData;
        } else {
          console.log(`No existing vote found for Policy ${policyId}, CMS ${cmsId}`);
          return null;
        }
      } catch (error: any) {
        console.error("CMS Policy API Error - Find Vote:", error.response?.data || error);
        requestManager.recordError();
        return null;
      }
    };

    // Update existing vote - CMS API Requirements
    updateVote = async (recordId: string, voteData: any): Promise<any> => {
      const requestManager = RequestManager.getInstance();
      const endpoint = 'updateVote';
      
      // Check rate limiting
      if (!requestManager.canMakeRequest(endpoint)) {
        console.warn("updateVote request blocked by rate limiter");
        return false;
      }

      try {
        // Check if we have a valid JWT
        if (!this.JWT) {
          console.error("No JWT token available for updateVote");
          return false;
        }

        // Record this request
        requestManager.recordRequest(endpoint);

        // Exact structure from CMS API requirements
        const updateData = {
          fieldData: {
            "Vote": voteData.vote,
            "Comment": voteData.comment || ""
          }
        };

        console.log("Update Vote API Request:", JSON.stringify(updateData, null, 2));

        const resp = await axios.patch(
          `${this.domain}/layouts/Policy Votes/records/${recordId}`,
          updateData,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.JWT}`,
            },
            timeout: 10000
          }
        );

        console.log("Update Vote API Response:", resp.data);
        return resp.data.response;
      } catch (error: any) {
        console.error("CMS Policy API Error - Update Vote:", error.response?.data || error);
        requestManager.recordError();
        return false;
      }
    };


    findBillingCharges = async (Organization: any): Promise<any> => {
      try {
        let query = {
          query: [
            {
                "Dues Year": new Date().getFullYear(),
                "Organization": Organization,
                "Membership Classification": "Active"
            },
          ],
          "limit": "1000",
          "offset": "1"
        };
        const resp = await axios.post(
          `${this.domain}/layouts/Billing Charges/_find`,
          query,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.JWT}`,
            },
          }
        );

        return resp.data.response.data;
      } catch (error: any) {
        console.error("CMS Policy API Error:", error.resp.data);
        return false;
      }
    };

    // Central Line Voting Workflow API Methods
    
    // Get policy details by ID - CMS API Requirements
    getPolicyDetails = async (policyId: string): Promise<any> => {
      try {
        // Exact query structure from CMS API requirements
        const query = {
          query: [{
            "ID": policyId
          }]
        };
        
        
        const resp = await axios.post(
          `${this.domain}/layouts/Policies/_find`,
          query,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.JWT}`,
            },
            timeout: 10000
          }
        );
        
        
        // Validate response structure
        if (resp.data?.response?.data && resp.data.response.data.length > 0) {
          const policy = resp.data.response.data[0];
          return policy;
        } else {
          console.warn(`No policy found with ID ${policyId}`);
          return null;
        }
      } catch (error: any) {
        console.error("CMS Policy API Error - Policy Details:", error.response?.data || error);
        return null;
      }
    };
    
    // Get Loop 1 eligible members (Interest area based) - CMS API Requirements
    getLoop1EligibleMembers = async (policyInterestId: string): Promise<any> => {
      try {
        // Exact query structure from CMS API requirements
        const query = {
          query: [{
            "Policy Interest ID": policyInterestId,
            "MITS::Member?": "Yes",
            "MITS::Email Valid": "Yes"
          }]
        };
        
        
        const resp = await axios.post(
          `${this.domain}/layouts/Policy Interest to mits/_find`,
          query,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.JWT}`,
            },
            timeout: 10000
          }
        );
        
        
        // Validate response structure
        if (resp.data?.response?.data) {
          return resp.data.response.data;
        } else {
          console.warn("Unexpected Loop 1 API response structure:", resp.data);
          return [];
        }
      } catch (error: any) {
        console.error("CMS Policy API Error - Loop 1 Members:", error.response?.data || error);
        return [];
      }
    };

    // Get Loop 2 eligible members (All members except Loop 1) - CMS API Requirements
    getLoop2EligibleMembers = async (excludeCmsIds: string[]): Promise<any> => {
      try {
        // Exact query structure from CMS API requirements
        const query = {
          query: [{
            "Member?": "Yes",
            "Email Valid": "Yes"
          }],
          "limit": 1000,
          "offset": 1
        };
        
        
        const resp = await axios.post(
          `${this.domain}/layouts/Policy Member Info/_find`,
          query,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.JWT}`,
            },
            timeout: 10000
          }
        );
        
        
        // Validate response structure
        if (resp.data?.response?.data) {
          const allMembers = resp.data.response.data;
          
          // Filter out Loop 1 members
          const loop2Members = allMembers.filter((member: any) => {
            const cmsId = member.fieldData["CMS ID"]?.toString();
            const isExcluded = excludeCmsIds.includes(cmsId);
            return !isExcluded;
          });
          
          console.log(`Found ${loop2Members.length} Loop 2 eligible members (excluding ${excludeCmsIds.length} Loop 1 members)`);
          return loop2Members;
        } else {
          console.warn("Unexpected Loop 2 API response structure:", resp.data);
          return [];
        }
      } catch (error: any) {
        console.error("CMS Policy API Error - Loop 2 Members:", error.response?.data || error);
        return [];
      }
    };

      async findUserByCmsId(cmsId: string): Promise<any> {
        try {
          console.log('Finding user by CMS ID:', cmsId);
          
          const response = await axios.post(
            `${this.domain}/layouts/Policy Member Info/_find`,
            {
              query: [
                {
                  "CMS ID": cmsId
                }
              ]
            },
            {
              headers: {
                'Authorization': `Bearer ${this.JWT}`,
                'Content-Type': 'application/json'
              }
            }
          );
    
          if (response.data?.response?.data && response.data.response.data.length > 0) {
            const userData = response.data.response.data[0];
            return {
              recordId: userData.recordId,
              cmsId: userData.fieldData["CMS ID"],
              fullName: userData.fieldData["Full Name"],
              emailAddress: userData.fieldData["Email Address"],
              usertype: userData.fieldData["Policy User Type"],
              policyPreferredCommunication: userData.fieldData["Policy Preferred Communication"]
            };
          }
          return null;
        } catch (error) {
          console.error('Error finding user:', error);
          throw error;
        }
      }

    // Get Loop 3 eligible members (All members except board members) - CMS API Requirements
    getLoop3EligibleMembers = async (): Promise<any> => {
      try {
        // Get board members first using the exact API from requirements
        const boardMembers = await this.getBoardMembers();
        const boardMemberIds = boardMembers.map((member: any) => member.fieldData?.["CMS ID"]?.toString());
        
        console.log(`Found ${boardMemberIds.length} board members to exclude:`, boardMemberIds);
        
        // Get all eligible members using exact query from requirements
        const query = {
          query: [{
            "Member?": "Yes",
            "Email Valid": "Yes"
          }],
          "limit": 1000,
          "offset": 1
        };
        
        console.log("Loop 3 API Query:", JSON.stringify(query, null, 2));
        
        const resp = await axios.post(
          `${this.domain}/layouts/Policy Member Info/_find`,
          query,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.JWT}`,
            },
            timeout: 10000
          }
        );
        
        console.log("Loop 3 API Response:", resp.data);
        
        // Validate response structure
        if (resp.data?.response?.data) {
          const allMembers = resp.data.response.data;
          
          // Filter out board members using the board member IDs
          const loop3Members = allMembers.filter((member: any) => {
            const cmsId = member.fieldData?.["CMS ID"]?.toString();
            const isBoardMember = boardMemberIds.includes(cmsId);
            return !isBoardMember;
          });
          
          console.log(`Found ${loop3Members.length} Loop 3 eligible members (excluding ${boardMemberIds.length} board members)`);
          return loop3Members;
        } else {
          console.warn("Unexpected Loop 3 API response structure:", resp.data);
          return [];
        }
      } catch (error: any) {
        console.error("CMS Policy API Error - Loop 3 Members:", error.response?.data || error);
        return [];
      }
    };

    // Get Policy BOD Meeting details for Loop 3 Release status - CMS API Requirements
    getPolicyBODMeeting = async (meetingId: string): Promise<any> => {
      try {
        // Exact query structure from CMS API requirements
        const query = {
          query: [{ "ID": meetingId }]
        };
        
        console.log("Policy BOD Mtg API Query:", JSON.stringify(query, null, 2));
        
        const resp = await axios.post(
          `${this.domain}/layouts/Policy BOD Mtg/_find`,
          query,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.JWT}`,
            },
            timeout: 10000
          }
        );
        
        console.log("Policy BOD Mtg API Response:", resp.data);
        
        // Validate response structure
        if (resp.data?.response?.data && resp.data.response.data.length > 0) {
          const meetingData = resp.data.response.data[0];
          console.log(`Found Policy BOD Meeting data for ID ${meetingId}`);
          return meetingData;
        } else {
          console.warn("Unexpected Policy BOD Mtg API response structure:", resp.data);
          return null;
        }
      } catch (error: any) {
        console.error("CMS Policy API Error - Policy BOD Mtg:", error.response?.data || error);
        return null;
      }
    };

    // Get Board Members using View layout - CMS API Requirements
    getBoardMembers = async (): Promise<any> => {
      try {
        // Exact query structure from CMS API requirements
        const query = {
          query: [
            {
              "Member?": "Yes",
              "Activities::Activity": "CMS Board of Directors",
              "Activities::Status": "Current"
            },
            {
              "Member?": "Yes",
              "Activities::Activity": "CMS BOD/Officers",
              "Activities::Status": "Current"
            }
          ]
        };
        
        console.log("Board Members API Query:", JSON.stringify(query, null, 2));
        
        const resp = await axios.post(
          `${this.domain}/layouts/View/_find`,
          query,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.JWT}`,
            },
            timeout: 10000
          }
        );
        
        console.log("Board Members API Response:", resp.data);
        
        // Validate response structure
        if (resp.data?.response?.data) {
          const boardMembers = resp.data.response.data;
          console.log(`Found ${boardMembers.length} board members`);
          return boardMembers;
        } else {
          console.warn("Unexpected Board Members API response structure:", resp.data);
          return [];
        }
      } catch (error: any) {
        console.error("CMS Policy API Error - Board Members:", error.response?.data || error);
        return [];
      }
    };

    // Check if user is a board member - CMS API Requirements
    isBoardMember = (member: any): boolean => {
      try {
        // Use Activities field as per CMS API requirements
        // Requirements: Activities::Activity = "CMS Board of Directors" or "CMS BOD/Officers" and Activities::Status = "Current"
        const activities = member.fieldData["Activities"] || [];
        const memberStatus = member.fieldData["Member?"] || "";
        
        // Check if member is a board member based on activities
        const isBoardMember = activities.some((activity: any) => {
          const activityName = activity.fieldData?.["Activity"] || "";
          const activityStatus = activity.fieldData?.["Status"] || "";
          
          return (activityName === "CMS Board of Directors" || activityName === "CMS BOD/Officers") &&
                 activityStatus === "Current";
        });
        
        // Also check if member status is Yes
        const isActiveMember = memberStatus === "Yes";
        
        console.log(`Board member check for CMS ID ${member.fieldData["CMS ID"]}:`, {
          activities, memberStatus, isBoardMember, isActiveMember
        });
        
        return isBoardMember && isActiveMember;
      } catch (error) {
        console.error("Error checking board member status:", error);
        return false;
      }
    };

// Check user eligibility for specific loop
  checkUserEligibility = async (userId: string, proposal: any, loop: number): Promise<boolean> => {
    try {
      console.log(`🔍 FileMaker: Checking user eligibility for Loop ${loop}, User: ${userId}`);
      
      // For testing purposes, allow all users in Loop 1 and 2
      if (loop === 1 || loop === 2) {
        console.log(`✅ FileMaker: Allowing user ${userId} for Loop ${loop} (testing mode)`);
        return true;
      }
      
      // Only check eligibility for Loop 3
      if (loop === 3) {
        console.log(`🔄 FileMaker: Getting Loop 3 eligible members (excluding board members)...`);
        const loop3Members = await this.getLoop3EligibleMembers();
        console.log(`📊 FileMaker: Found ${loop3Members.length} Loop 3 members`);
        
        const isEligible = loop3Members.some(
          (member: any) => member.fieldData["CMS ID"]?.toString() === userId
        );
        
        console.log(`📊 FileMaker: User ${userId} eligible for Loop 3: ${isEligible}`);
        return isEligible;
      }

      console.log(`❌ FileMaker: Unknown loop ${loop}`);
      return false;
    } catch (error) {
      console.error("❌ FileMaker: Error checking user eligibility:", error);
      // In case of error, allow voting as fallback for testing
      console.log("✅ FileMaker: Allowing vote as fallback due to error");
      return true;
    }
  };


    // Get current date in US Mountain Time (Denver time)
  private getCurrentMountainDate(): Date {
    try {
      const now = new Date();
      
      // Convert to Mountain Time (America/Denver) to get the correct date
      const mountainTimeOptions: Intl.DateTimeFormatOptions = {
        timeZone: 'America/Denver',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      };
      
      const formatter = new Intl.DateTimeFormat('en-US', mountainTimeOptions);
      const parts = formatter.formatToParts(now);
      
      const year = parts.find(part => part.type === 'year')?.value;
      const month = parts.find(part => part.type === 'month')?.value;
      const day = parts.find(part => part.type === 'day')?.value;
      
      if (year && month && day) {
        // Create date-only object (time set to 00:00:00)
        const mountainDate = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
        
        console.log('📅 FileMaker Mountain Date:', {
          UTC: now.toISOString(),
          MountainDate: mountainDate.toISOString(),
          MountainDateFormatted: mountainDate.toLocaleDateString('en-US', { timeZone: 'America/Denver' })
        });
        
        return mountainDate;
      }
      
      console.warn('FileMaker: Could not format Mountain Date, using current date as fallback');
      return this.toDateOnly(now);
    } catch (error) {
      console.error('FileMaker: Error getting Mountain Date:', error);
      return this.toDateOnly(new Date());
    }
  }
   // Check if voting is open for a specific loop (date-only comparison)
  isVotingOpen = async (proposal: any, loop: number): Promise<boolean> => {
    // Get current date in US Mountain Time (Denver time)
    const today = this.getCurrentMountainDate();
    
    console.log(`📅 FileMaker: Checking voting for Loop ${loop} at Mountain Date:`, today.toISOString());
    
    switch (loop) {
      case 1:
        // Loop 1: Begins at Interested Feedback Start Date and ends at Loop 1 End Date
        const loop1Start = this.parseDate(proposal.fieldData["Policy BOD Mtg::Loop 1 Start Date"]);
        const loop1EndDate = this.parseDate(proposal.fieldData["Policy BOD Mtg::Loop 1 End Date"]);
        
        if (!this.isDateRangeValid(loop1Start, loop1EndDate)) {
          console.warn("FileMaker: Invalid Loop 1 date range:", { loop1Start, loop1EndDate });
          return false;
        }
        
        const loop1Open = today >= loop1Start! && today <= loop1EndDate!;
        console.log(`FileMaker: Loop 1 voting check:`, {
          today: today.toISOString(), 
          loop1Start: loop1Start?.toISOString(), 
          loop1EndDate: loop1EndDate?.toISOString(), 
          loop1Open
        });
        return loop1Open;
        
      case 2:
        // Loop 2: From General Feedback Start Date to General Feedback End Date
        const loop2Start = this.parseDate(proposal.fieldData["Policy BOD Mtg::Loop 2 Start Date"]);
        const loop2End = this.parseDate(proposal.fieldData["Policy BOD Mtg::Loop 2 End Date"]);
        
        if (!this.isDateRangeValid(loop2Start, loop2End)) {
          console.warn("FileMaker: Invalid Loop 2 date range:", { loop2Start, loop2End });
          return false;
        }
        
        const loop2Open = today >= loop2Start! && today <= loop2End!;
        console.log(`FileMaker: Loop 2 voting check:`, {
          today: today.toISOString(), 
          loop2Start: loop2Start?.toISOString(), 
          loop2End: loop2End?.toISOString(), 
          loop2Open
        });
        return loop2Open;
        
      case 3:
        // Loop 3: From Board Action Start Date to Board Action End Date
        // Additional Condition: Voting can also be allowed if Loop 3 Release = Yes
        const loop3Start = this.parseDate(proposal.fieldData["Policy BOD Mtg::Loop 3 Start Date"]);
        const loop3End = this.parseDate(proposal.fieldData["Policy BOD Mtg::Loop 3 End Date"]);
        
        // Get Loop 3 Release status from Policy BOD Mtg API
        let loop3Release = false;
        try {
          const meetingId = proposal.fieldData["Policy Board Mtg ID"];
          if (meetingId) {
            const meetingData = await this.getPolicyBODMeeting(meetingId.toString());
            if (meetingData) {
              loop3Release = meetingData.fieldData?.["Loop 3 Release"] === "Yes";
              console.log(`FileMaker: Loop 3 Release status: ${loop3Release} (from Policy BOD Mtg ID: ${meetingId})`);
            }
          }
        } catch (error) {
          console.warn("FileMaker: Could not fetch Loop 3 Release status:", error);
        }
        
        // Check if date range is valid (if not using release status)
        const isDateRangeValidForLoop3 = this.isDateRangeValid(loop3Start, loop3End);
        const isInDateRange = isDateRangeValidForLoop3 && today >= loop3Start! && today <= loop3End!;
        
        const isOpen = isInDateRange || loop3Release;
        
        console.log(`FileMaker: Loop 3 voting check:`, {
          today: today.toISOString(), 
          loop3Start: loop3Start?.toISOString(), 
          loop3End: loop3End?.toISOString(), 
          loop3Release, 
          isInDateRange, 
          isOpen
        });
        
        return isOpen;
        
      default:
        return false;
    }
  };


private getCurrentMountainTime = (): Date => {
  try {
    const now = new Date();
    
    // Convert to Mountain Time (America/Denver)
    const mountainTimeOptions: Intl.DateTimeFormatOptions = {
      timeZone: 'America/Denver',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    };
    
    const formatter = new Intl.DateTimeFormat('en-US', mountainTimeOptions);
    const parts = formatter.formatToParts(now);
    
    const year = parts.find(part => part.type === 'year')?.value;
    const month = parts.find(part => part.type === 'month')?.value;
    const day = parts.find(part => part.type === 'day')?.value;
    const hour = parts.find(part => part.type === 'hour')?.value;
    const minute = parts.find(part => part.type === 'minute')?.value;
    const second = parts.find(part => part.type === 'second')?.value;
    
    if (year && month && day && hour && minute && second) {
      // Create ISO string in Mountain Time (treat as UTC to avoid double conversion)
      const mountainTimeString = `${year}-${month}-${day}T${hour}:${minute}:${second}`;
      const mountainTime = new Date(mountainTimeString + 'Z');
      
      console.log('🕒 FileMaker Mountain Time:', {
        UTC: now.toISOString(),
        Mountain: mountainTime.toISOString(),
        MountainLocal: mountainTime.toLocaleString('en-US', { timeZone: 'America/Denver' })
      });
      
      return mountainTime;
    }
    
    console.warn('FileMaker: Could not format Mountain Time, using current time as fallback');
    return now;
  } catch (error) {
    console.error('FileMaker: Error getting Mountain Time:', error);
    return new Date();
  }
};

  // Convert to date-only (time set to 00:00:00)
  private toDateOnly(date: Date): Date {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }
  // Parse date with Mountain Time consideration (time-agnostic)
  private parseDate(raw: string | undefined): Date | null {
    if (!raw) return null;
    
    try {
      let date: Date;
      
      // Handle various date formats
      if (raw.includes('-') && raw.length >= 10) {
        // ISO format - extract date part only
        const datePart = raw.split('T')[0]; // Get YYYY-MM-DD part
        const [year, month, day] = datePart.split('-').map(Number);
        date = new Date(year, month - 1, day);
      } else if (raw.includes('/')) {
        // MM/DD/YYYY format
        const parts = raw.split('/');
        if (parts.length === 3) {
          const month = parseInt(parts[0]) - 1;
          const day = parseInt(parts[1]);
          const year = parseInt(parts[2]);
          date = new Date(year, month, day);
        } else {
          // Fallback for other formats
          const parsed = new Date(raw);
          date = this.toDateOnly(parsed);
        }
      } else {
        // Fallback for other formats
        const parsed = new Date(raw);
        date = this.toDateOnly(parsed);
      }
      
      if (isNaN(date.getTime())) {
        console.warn(`FileMaker: Invalid date format: ${raw}`);
        return null;
      }
      
      // Validate reasonable date range
      const year = date.getFullYear();
      if (year < 1900 || year > 2100) {
        console.warn(`FileMaker: Date out of range: ${raw} (year: ${year})`);
        return null;
      }
      
      console.log(`📅 FileMaker parsed date: ${raw} -> ${date.toISOString()}`);
      return date;
    } catch (error) {
      console.warn(`FileMaker: Error parsing date: ${raw}`, error);
      return null;
    }
  }

 
  // Helper method to check if date range is valid
  private isDateRangeValid = (startDate: Date | null, endDate: Date | null): boolean => {
    if (!startDate || !endDate) {
      console.warn("Invalid date range: missing start or end date", { startDate, endDate });
      return false;
    }
    
    // Check if start date is before end date
    if (startDate > endDate) {
      console.warn("Invalid date range: start date is after end date", { 
        startDate: startDate.toISOString(), 
        endDate: endDate.toISOString() 
      });
      return false;
    }
    
    // Check if dates are too far apart (more than 1 year)
    const diffInDays = Math.abs(endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24);
    if (diffInDays > 365) {
      console.warn("Date range is unusually long (more than 1 year)", { 
        startDate: startDate.toISOString(), 
        endDate: endDate.toISOString(),
        diffInDays: Math.round(diffInDays)
      });
    }
    
    return true;
  };

    // Helper method to safely extract Policy Interest ID
    private getPolicyInterestId = (proposal: any): string | null => {
      if (!proposal || !proposal.fieldData) {
        console.warn("Invalid proposal data for Policy Interest ID extraction");
        return null;
      }

      const policyInterests = proposal.fieldData["Policy Interests"];
      if (!policyInterests) {
        console.warn("Policy Interests field not found in proposal data");
        return null;
      }

      // Handle different data types
      const interestId = typeof policyInterests === 'string' 
        ? policyInterests.trim() 
        : policyInterests.toString().trim();

      if (!interestId || interestId === 'null' || interestId === 'undefined') {
        console.warn("Policy Interest ID is empty or invalid:", policyInterests);
        return null;
      }

      console.log(`Extracted Policy Interest ID: ${interestId}`);
      return interestId;
    };

    // Get token details from Policy Token layout - for unsubscribe functionality
    getTokenDetails = async (token: string, retryCount = 0, allowUsedTokens = false): Promise<any> => {
      const maxRetries = 3;
      const retryDelay = 1000; // 1 second
      
      try {
        const query = {
          query: [
            {
              "Token": token
            }
          ]
        };
        
        console.log("Policy Token API Query:", JSON.stringify(query, null, 2));
        
        const resp = await axios.post(
          `${this.domain}/layouts/Policy Token/_find`,
          query,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.JWT}`,
            },
            timeout: 10000
          }
        );
        
        console.log("Policy Token API Response:", resp.data);
        
        // Validate response structure
        if (resp.data?.response?.data && resp.data.response.data.length > 0) {
          const tokenData = resp.data.response.data[0];
          console.log(`Found token details for token: ${token}`);
          
          // Check if token is already used (only for login tokens, not unsubscribe tokens)
          const tokenStatus = tokenData.fieldData?.["Status"];
          // if (tokenStatus === "Used" && !allowUsedTokens) {
          //   console.warn(`Token ${token} has already been used`);
          //   return {
          //     success: false,
          //     error: "Token has already been used. Please login from here.",
          //     tokenUsed: true
          //   };
          // }
          
          return {
            success: true,
            data: {
              cmsId: tokenData.fieldData?.["CMS ID"],
              policyBoardMtgId: tokenData.fieldData?.["Policy Board Mtg ID"],
              policyIdeaId: tokenData.fieldData?.["Policy Idea ID"],
              token: tokenData.fieldData?.["Token"],
              status: tokenStatus,
              recordId: tokenData.recordId
            }
          };
        } else {
          console.warn(`No token found with value: ${token}`);
          return {
            success: false,
            error: "Token not found"
          };
        }
      } catch (error: any) {
        console.error("CMS Policy API Error - Token Details:", error.response?.data || error);
        
        // Check if it's a "record in use" error and we can retry
        if (error.response?.data?.messages) {
          const apiError = error.response.data.messages[0];
          if (apiError.code === '301' && retryCount < maxRetries) {
            console.warn(`Record in use error (${apiError.code}). Retrying in ${retryDelay}ms... (Attempt ${retryCount + 1}/${maxRetries})`);
            await new Promise(resolve => setTimeout(resolve, retryDelay));
            return await this.getTokenDetails(token, retryCount + 1);
          }
          
          // Handle invalid token error (code 952)
          if (apiError.code === '952') {
            return {
              success: false,
              error: `Invalid FileMaker Data API token (${apiError.code})`
            };
          }
        }
        
        return {
          success: false,
          error: error.response?.data?.messages?.[0]?.message || error.message || "Failed to fetch token details"
        };
      }
    };

}

export default FileMaker;
